import { render, staticRenderFns } from "./platform_user_detail.vue?vue&type=template&id=5e8cc6d6&scoped=true"
import script from "./platform_user_detail.vue?vue&type=script&lang=js"
export * from "./platform_user_detail.vue?vue&type=script&lang=js"
import style0 from "./platform_user_detail.vue?vue&type=style&index=0&id=5e8cc6d6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8cc6d6",
  null
  
)

export default component.exports